import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import styled from 'styled-components'

const FrontElement = ({ children }: { children: React.ReactNode }) => {
  return (
    <TextWidthWrapper>
      <TextWidth>
        <FrontElementWrapper>{children}</FrontElementWrapper>
      </TextWidth>
    </TextWidthWrapper>
  )
}
const TextWidthWrapper = styled.div`
  .content {
    @media (max-width: 370px) {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
`
const FrontElementWrapper = styled.div`
  h3 {
    font-family: var(--font-plex);
    font-size: 1.5em;
    text-align: center;
    border-bottom: 1px solid #7b7b7b36;
    padding-bottom: 1em;
    margin-top: 0.5em;
  }
  border: 1px solid #000000e8;
  box-sizing: border-box;
  font-size: 18px;
  line-height: 23px;
  font-family: var(--font-plex);
  /* min-height: 100vh; */
  z-index: 1;
  background-color: var(--front-element-background);
  backdrop-filter: blur(5px);
  padding: 1em;
  border: 1px;
  border-color: #000000e8;
  text-align: center;
  line-height: 1.5em;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 10px 0px;
  border-radius: 5px;
  text-align: left;
  font-family: var(--font-noto);

  img {
    /* z-index: 0; */
    max-width: 100%;
  }
  p {
    /* background-color: var(--site-background); */
  }
`
export default FrontElement
